import { assetsDataManagerObjectClassesSettingsEntryPoint } from '@jira/spa-apps__data-manager-object-classes-settings/src/assetsDataManagerObjectClassesSettingsEntryPoint.entrypoint.tsx';
import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsDataManagerObjectClassesSettingsRoute } from '@jira/router-routes__assets-app-data-manager-routes/src/assetsDataManagerObjectClassesSettingsRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router';

const assetsDataManagerObjectClassSettingsPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerObjectClassesSettingsEntryPoint,
});

export const assetsDataManagerObjectClassesSettingsRouteEntry: Route = createEntry(
	assetsDataManagerObjectClassesSettingsRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		perfMetricKey: 'assets-data-manager-object-classes-settings',
		ufoName: 'assets-data-manager-object-classes-settings',
		pageId: ({ match }) => {
			const settingType = match.params?.settingType;
			return settingType
				? `spa-apps/assets-data-manager-object-classes-settings-${settingType}`
				: 'spa-apps/assets-data-manager-object-classes-settings';
		},
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerObjectClassSettingsPageEntryPoint
				: undefined;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,
		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASSES_SETTINGS_PAGE),
				teamName: 'Aurum',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
